import { keys } from './utils';

function addFocusClass(e) {
	if (e.type == 'keydown') {
		if ([9, 38, 40].includes(e.keyCode)) {
			 $('body').addClass('tabPressed');
		}
	} else {
		if (['INPUT','BUTTON','A'].indexOf(e.target.tagName) < 0) {
			$(this).removeClass('tabPressed');
		}
	}
}

function addNewTabIndicator($item) {
	const indicator = $('#newTabIndicator').html();
	const label = $item.attr('aria-label');

	if ( label ) {
		$item.attr('aria-label', label + ', ' + $(indicator).text());
	} else {
		$item.append(indicator);
	}
}

/* Inside a modal for example, when a user uses the tab
   the keyboard focus needs to stay inside the modal on navigation */
export function initLoopTraps($elements) {
	$elements.each(function(){
		const $container = $(this);
		const $firstEl = $container.find('a:visible:not([tabindex="-1"]),button:visible:not([tabindex="-1"]),input:visible:not([tabindex="-1"])').first();
		const $lastEl = $container.find('a:visible:not([tabindex="-1"]),button:visible:not([tabindex="-1"]),input:visible:not([tabindex="-1"])').last();

		$lastEl.on('keydown', function(e){
			if (e.keyCode == keys.tab && !e.shiftKey) {
				e.preventDefault();
				$firstEl.focus();
			}
		});

		$firstEl.on('keydown', function(e){
			if (e.keyCode == keys.tab && e.shiftKey) {
				e.preventDefault();
				$lastEl.focus();
			}
		});
	});
}

const manageAriaExpanded = () => {

  if(document.querySelectorAll('.bs-toggle').length){
    document.querySelectorAll('.bs-toggle').forEach(element => {
      const modalToggle = element;
      const modalTarget = modalToggle.dataset.target;

      $(modalTarget).on('shown.bs.modal', function (e) {
        modalToggle.setAttribute('aria-expanded', 'true');
      });

      $(modalTarget).on('hidden.bs.modal', function (e) {
        modalToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }
}

const init = () => {
	$('body').on('click keydown', addFocusClass);

	$('a[target="_blank"]:not(.no-label)').each(function() {
		addNewTabIndicator($(this))
	});

	initLoopTraps($('.js-loop-trap'));

	manageAriaExpanded();

}

export default init;
